<template>
  <Header />
  <Contents />
  <Footer />
</template>

<script>
import Header from "@/components/HeaderSub.vue";
import Contents from "@/components/ColumnList.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ColumnList",
  components: { Header, Contents, Footer },
  mounted() {
    const title = "コラム記事一覧 | MOG(モグー) ボートレース蒲郡";
    const description =
      "GAMA専門家によるモーター分析やレース考察などのコラム記事一覧です。";
    document.title = title;
    document
      .querySelector("meta[property='og:title']")
      .setAttribute("content", title);
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", description);
    document
      .querySelector("meta[property='og:description']")
      .setAttribute("content", description);
  },
};
</script>
